<i18n lang='yml' src='../i18n/InviteUserForm.yml'></i18n>
<template>
    <div>
      <flash :message_type="message_type" :message_text="message_text"/>
      <Form ref="observer" v-slot="{ errors }" @submit  ="submitUserInput" @invalid-submit="setErrorMessage">
          <h5 class="border-bottom heading-page">
            {{$t('add_new_member')}}
          </h5>
          <div class="row">
            <div class="form-group col-sm-4">
              <label> {{$t('name')}} </label>
              <Field
                :name="$t('name')" 
                rules="required"
                v-slot="{ errors, field }"
                v-model="name">
                <input 
                  :class="{'is-invalid': errors[0]}"
                  name="invitee_name" 
                  type="text" 
                  class="form-control" 
                  v-bind="field">
                <div class="invalid-feedback" :id="`${$t('name')}_error`" v-if="errors[0]">
                  <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                  <span>{{ errors[0] }}</span> 
                </div>
              </Field> 
            </div>
            <div class="form-group col-sm-4">
              <label> {{$t('email')}} </label>
              <Field
                :name="$t('email')" 
                :rules="{ required: true, regex: ['email', $t('email').toLowerCase()]}"
                v-slot="{ errors, field}"
                v-model="email">
                <input 
                  :class="{'is-invalid': errors[0]}"
                  name="invitee_email" 
                  type="text" 
                  class="form-control" 
                  v-bind="field" 
                  >
                <div class="invalid-feedback" :id="`${$t('email')}_error`" v-if="errors[0]">
                  <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                  <span>{{ errors[0] }}</span> 
                </div>
              </Field> 
            </div>
            <div class="form-group col-sm-4">
              <label> {{$t('role')}} </label>
              <select class='form-control' v-model="role">
                <option :key="item.id" v-for='item in roles' :value="item.id" >
                  {{ (item.name_en) }}
                </option>
              </select>
            </div>
          </div>
          <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
            <span class="red mr-2">
              <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
            </span>
            {{ $t('error_warning') }}
          </div>
          <div class="row">
            <div class="form-group col-sm-4">
              <label> {{$t('auto_register_containers')}} </label>
              <containerSelection :containers="containers" :clear="clear" :input_name="container_input_name" v-model="registered_containers"></containerSelection>
            </div>

            <div class="form-group col-sm-4 mt-auto">
              <button type="submit" class="btn btn-primary btn-success no-shadow">
                <font-awesome-icon :icon="['fa', 'user-plus']"  />
                {{ $t('submit') }}
              </button>
            </div>
          </div>
      </Form>
    </div>
</template>
<script>
  import flash from '../../../../shared/flash_messages/components/Flash.vue';
  import '../../../../../javascripts/application/vee-validate-rules.js'
  import containerSelection from '../../memberships/components/ContainerSelection.vue';
  import { sendAjaxRequest } from '../../../../shared/typescripts/ajax.ts'
  import { setErrorMessage } from '../../../../shared/typescripts/error.ts'
  import { Form, Field } from 'vee-validate'


  export default {
      components: { 
          containerSelection,
          flash,
          Form, 
          Field 
        },
      props: {
          locale: String,
          load_path: String,
          network_roles: String,
          containers: String,
          container_input_name: String
      },

      data(){
        return{
            name: null,
            email: null,
            role: "",
            message_text: [],
            message_type: "",
            showErrorBanner: false,
            registered_containers: [],
            roles: [],
            responses: [],
            errors: {},
            clear: false
        };
      },

      mounted() {
        this.$i18n.locale = this.locale;
        
        //Set roles to the first of network_roles so we can use it as a default for the dropdown.
        try {
            this.roles = JSON.parse(this.network_roles);
            this.role = this.roles[0].id;
        }
        catch(err) {
            this.error = true;
        }
      },

      methods: {
          submitUserInput(){
          this.clear = false
          let payload = []
    
          if (event.target.elements['auto_register_containers[]']) {
            Object.values(event.target.elements['auto_register_containers[]']).forEach((val) => {
                //The value changes dependant on how many containers are selected.
                //When there is a singluar container it passed a nuber, when there are multiple it passes and object.
                if(typeof val == 'number'){
                    this.registered_containers.push(val);
                }
                else {
                    this.registered_containers.push(val.value);
                }
            });
          } 

          payload = {invitation_code: {invitee_name: this.name, 
          invitee_email: this.email, 
          network_role_id: this.role, 
          auto_register_containers: this.registered_containers}}

          this.message_text = [];
          sendAjaxRequest('POST', this.load_path, 'json', payload, this.ajaxSuccess)

          //Clear registered contains to prevent previous data being pushed to new users.
          this.registered_containers = [];
        },

        ajaxSuccess(response) {
            if(response.error){
            this.message_type = "error";
            this.message_text.push(response.error)
            }
            else {
            window.location.replace(response.path);
            }
        },

        setErrorMessage({ valuese, errors, results }) {
          setErrorMessage(this, errors)
        }
      },   
    }
</script>
